/**
 * This mixin is responsible to add ThisFlow tab to the DataInputMenu
 */

import ThisFlowMixinService from './this-flow-mixin-service';

export default {
	mixins: [],
	methods: {},
	mounted() {
		ThisFlowMixinService.addThisFlowTabItem.call(this);
	},
};
